import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { CompareBar } from '@/components/compare';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1 pb-20">{children}</main>
      <Footer />
      <CompareBar />
    </div>
  );
}
